import styled from 'styled-components'

import Link from 'v2/components/UserDropdown/components/Link'

export default styled(Link).attrs({
  f: 2,
  fontWeight: 'normal',
})`
  display: flex;
  align-items: center;
`
